<template>
  <ul @click="onPagerClick" class="zm-pager">
    <li
      :class="{ active: currentPage === 1, disabled }"
      v-if="pageCount > 0 && !noJump"
      class="number"
      role="button"
      :aria-label="getAria(1)"
      :tabindex="disabled?-1:0"
    >
      1
    </li>
    <li
      class="zm-icon more btn-quickprev"
      :class="[quickprevIconClass]"
      v-if="showPrevMore && !noJump"
    >
    </li>
    <li
      v-for="pager in pagers"
      :key="pager"
      :class="{ active: currentPage === pager, disabled }"
      class="number"
      role="button"
      :tabindex="disabled?-1:0"
      :aria-label="getAria(pager)"
    >
      {{ pager }}
    </li>
    <li
      class="zm-icon more btn-quicknext"
      :class="[quicknextIconClass]"
      v-if="showNextMore && !noJump"
    >
    </li>
    <li
      :class="{ active: currentPage === pageCount, disabled }"
      class="number"
      v-if="pageCount > 1 && !noJump"
      role="button"
      :tabindex="disabled?-1:0"
      :aria-label="getAria(pageCount)"
    >
      {{ pageCount }}
    </li>
  </ul>
</template>

<script type="text/babel">
  import '../../../i18n/pagination';

  export default {
    name: 'ZmPager',

    props: {
      currentPage: Number,

      pageCount: Number,

      noJump: Boolean,

      pagerCount: Number,

      disabled: Boolean
    },

    watch: {
      showPrevMore(val) {
        if (!val) this.quickprevIconClass = 'zm-icon-more';
      },

      showNextMore(val) {
        if (!val) this.quicknextIconClass = 'zm-icon-more';
      }
    },

    methods: {
      onPagerClick(event) {
        const target = event.target;
        if (target.tagName === 'UL' || this.disabled || event.target.className.indexOf('more') !== -1) {
          return;
        }

        let newPage = Number(event.target.textContent);
        const pageCount = this.pageCount;
        const currentPage = this.currentPage;
        // const pagerCountOffset = this.pagerCount - 2;
        //
        // if (target.className.indexOf('more') !== -1) {
        //   if (target.className.indexOf('quickprev') !== -1) {
        //     newPage = currentPage - pagerCountOffset;
        //   } else if (target.className.indexOf('quicknext') !== -1) {
        //     newPage = currentPage + pagerCountOffset;
        //   }
        // }

        /* istanbul ignore if */
        if (!isNaN(newPage)) {
          if (newPage < 1) {
            newPage = 1;
          }

          if (newPage > pageCount) {
            newPage = pageCount;
          }
        }

        if (newPage !== currentPage) {
          this.$emit('change', newPage);
        }
      },

      getAria(page) {
        let aria = `Go to page ${page}`;
        if (page === this.currentPage) {
          aria += ',current page';
        }
        return aria;
      }

      // onMouseenter(direction) {
      //   if (this.disabled) return;
      //   if (direction === 'left') {
      //     this.quickprevIconClass = 'zm-icon-left';
      //   } else {
      //     this.quicknextIconClass = 'zm-icon-right';
      //   }
      // }
    },

    computed: {
      pagers() {
        const pagerCount = this.pagerCount;
        const halfPagerCount = (pagerCount - 1) / 2;

        const currentPage = Number(this.currentPage);
        const pageCount = Number(this.pageCount);

        let showPrevMore = false;
        let showNextMore = false;

        if (pageCount > pagerCount) {
          if (currentPage > pagerCount - halfPagerCount) {
            showPrevMore = true;
          }

          if (currentPage < pageCount - halfPagerCount) {
            showNextMore = true;
          }
        }

        const array = [];
        if (this.noJump) {
          array.push(currentPage);
        } else {
          if (showPrevMore && !showNextMore) {
            const startPage = pageCount - (pagerCount - 2);
            for (let i = startPage; i < pageCount; i++) {
              array.push(i);
            }
          } else if (!showPrevMore && showNextMore) {
            for (let i = 2; i < pagerCount; i++) {
              array.push(i);
            }
          } else if (showPrevMore && showNextMore) {
            const offset = Math.floor(pagerCount / 2) - 1;
            for (let i = currentPage - offset; i <= currentPage + offset; i++) {
              array.push(i);
            }
          } else {
            for (let i = 2; i < pageCount; i++) {
              array.push(i);
            }
          }
        }

        /* eslint-disable vue/no-side-effects-in-computed-properties */
        this.showPrevMore = showPrevMore;
        this.showNextMore = showNextMore;
        /* eslint-enable */

        return array;
      }
    },

    data() {
      return {
        current: null,
        showPrevMore: false,
        showNextMore: false,
        quicknextIconClass: 'zm-icon-more',
        quickprevIconClass: 'zm-icon-more'
      };
    }
  };
</script>

<style lang="scss">
  @import "style";
</style>
